
export const INSTITUTE_HANDLER = 'INSTITUTE_HANDLER';
export const FETCH_TEACHERS = 'FETCH_TEACHERS';
